import { img13, img14, img15, img16 } from '../assets/images';

export const programs = [
  {
    id: "playgroup",
    title: "Playgroup",
    age: "1.5 – 2.5 Years",
    duration: "3 Hours / Day",
    image: img13,
    color: "#FDE8E9",
    accentColor: "#C8161D",
    bgClass: "bg-[#FDE8E9]",
    textClass: "text-[#C8161D]",
    borderClass: "border-[#C8161D]/20",
    desc: "A warm introduction to the world of learning through music, storytelling, movement, sensory activities, playful interaction, and caring routines.",
    focusAreas: [
      "Social interaction & adaptation",
      "Sensory development & exploration",
      "Gross & fine motor skills",
      "Early language & communication",
      "Music, rhythm & movement",
      "Comfort & routine building",
      "Fun-based learning & play"
    ]
  },
  {
    id: "nursery",
    title: "Nursery",
    age: "2.5 – 3.5 Years",
    duration: "4 Hours / Day",
    image: img14,
    color: "#F3F9E2",
    accentColor: "#9DC41E",
    bgClass: "bg-[#F3F9E2]",
    textClass: "text-[#9DC41E]",
    borderClass: "border-[#9DC41E]/20",
    desc: "Children begin exploring language, numbers, creativity, confidence, and social skills through engaging activities and hands-on experiences.",
    focusAreas: [
      "Language development & vocab",
      "Pre-writing skills & shapes",
      "Creativity & imaginative arts",
      "Basic numeracy & sorting",
      "Emotional confidence & self-care",
      "Listening & following instructions",
      "Social participation & empathy"
    ]
  },
  {
    id: "lkg",
    title: "LKG",
    age: "3.5 – 4.5 Years",
    duration: "5 Hours / Day",
    image: img15,
    color: "#E0F2FE",
    accentColor: "#0284c7",
    bgClass: "bg-[#E0F2FE]",
    textClass: "text-[#0284c7]",
    borderClass: "border-[#0284c7]/20",
    desc: "Our structured and activity-rich curriculum helps children develop academic readiness while encouraging creativity, communication, problem-solving, and independent thinking.",
    focusAreas: [
      "Reading readiness & phonics",
      "Writing readiness & alphabet",
      "Logical thinking & counting 1-50",
      "Problem-solving & puzzle games",
      "Group learning & collaboration",
      "Independent working habits",
      "Environmental & community awareness"
    ]
  },
  {
    id: "ukg",
    title: "UKG",
    age: "4.5 – 5.5 Years",
    duration: "6 Hours / Day",
    image: img16,
    color: "#FEF9C3",
    accentColor: "#ca8a04",
    bgClass: "bg-[#FEF9C3]",
    textClass: "text-[#ca8a04]",
    borderClass: "border-[#ca8a04]/20",
    desc: "Children prepare for primary school with strong literacy, numeracy, communication, leadership, and school-readiness skills.",
    focusAreas: [
      "Full reading, phonics & writing",
      "Mathematics foundations (addition/sub)",
      "General awareness & science experiments",
      "Communication skills & presentation",
      "Leadership qualities & responsibilities",
      "Primary-school readiness & discipline",
      "Social responsibility & values"
    ]
  }
];
